import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=745c7bea&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745c7bea')) {
      api.createRecord('745c7bea', component.options)
    } else {
      api.reload('745c7bea', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=745c7bea&", function () {
      api.rerender('745c7bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45lgL9Rav6Nn2/JS/comp/ImgFallback.vue"
export default component.exports